/**
 * 分时走势(非面积线)
 */
import BaseContext from '../basecontext';
import MainDectorator from '../dectorator/maindectorator';
import { checkMainAuth, checkMainTitleAuth } from '../dectorator/checkauthdectorator/index.js';
import { LINE_TYPE } from '../setting.js';
import { checkMRI, checkHKM, checkAmerican } from '../../controller/util.js';
import Util, { mergeModelData, curryFun } from '../../util/index.js';
const model = {
  showAvg: {
    Type: Boolean
  },
  last_px: {
    Type: Array,
    Default: () => ([])
  },
  avg_px: {
    Type: Array,
    Required: false,
    Default: () => ([])
  },
  indexRF: {
    Type: Array,
    Default: () => ([])
  },
  showIndexRF: {
    Type: Boolean
  }
};
export default class TrendState extends MainDectorator(BaseContext) {
  constructor({ data, ...rest }) {
    super({ ...rest, data: mergeModelData(model, data) });
  }
  _calcRange() {
    const { avg_px, last_px, sealObj, showAvg } = this.state.data;
    const { basePx } = sealObj;
    const array = [last_px, [basePx]];
    let { maxValue, minValue } = this.calcRange({
      data: showAvg ? [avg_px].concat(array) : array,
      targetKey: 'value',
      isAdditional: true
    });
    // 计算最新价和均价的最大最小值
    if (maxValue - basePx > basePx - minValue) {
      minValue = 2 * basePx - maxValue;
    } else {
      maxValue = 2 * basePx - minValue;
    }
    // if (maxValue === minValue) {
    //   // 停牌个股等
    //   maxValue *= 1.01;
    //   minValue *= 0.99;
    // }
    this.maxValue = maxValue;
    this.minValue = minValue;
    this.baseValue = basePx;
  }
  _calcAxis() {
    // 计算各个点的Y轴坐标
    const { avg_px, last_px, showAvg, showIndexRF, indexRF } = this.state.data;
    const halfVal = this.maxValue - this.baseValue;
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'value',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({ data: last_px });
    showAvg && curryCalcAxis({ data: avg_px });
    if (showIndexRF) {
      indexRF.forEach(ele => {
        ele.value = ele.value * halfVal / 100;
      });
      this.calcAxis({ data: indexRF, targetKey: 'value', sourceKey: 'barHeight', isAdditional: true, indexRF: true });
    }
  }
  _drawMain() {
    const {
      left,
      width,
      top,
      height,
      bottom,
    } = this.availArea;
    const { avg_px, last_px, showAvg, showIndexRF, indexRF } = this.state.data;
    const { avgLine: avgOption, lastLine: lastOption, gridentColor } = this.option.Trend;
    const { LINE, GRIDENT } = LINE_TYPE;
    const middleY = top + height / 2;
    this._drawLine(LINE, last_px, left, bottom, lastOption.lineWidth, lastOption.color);
    showAvg && this._drawLine(LINE, avg_px, left, bottom, avgOption.lineWidth, avgOption.color);
    showIndexRF && this._drawBarMacd(indexRF, left, middleY, width);
  }
  _drawAxisY() {
    const {
      left,
      top,
      width,
      height,
      bottom,
      right
    } = this.availArea;
    const { sealObj } = this.state.data;
    // 画y轴坐标值
    const { ratioFixed } = sealObj;
    const ctx = this.context;
    const { sizeRatio, fontFamily, color } = this.option.Trend.axisY;
    ctx.font = sizeRatio * this.state.baseSize * this.dpr + "px " + fontFamily;

    // 纵坐标分为六段，每段的高、值
    const perHeight = height / 6;
    const perValue = (this.maxValue - this.baseValue) / 3;

    // 最高线
    ctx.textAlign = "left";
    ctx.textBaseline = "bottom";
    ctx.fillStyle = this.option.BaseContext.colorMap[1];
    const maxPercent = 100 * (this.maxValue - this.baseValue) / this.baseValue;
    ctx.fillText(this.maxValue.toFixed(ratioFixed), left, top);
    ctx.textAlign = "right";
    ctx.fillText(maxPercent.toFixed(2) + '%', right, top);

    // 第二条
    ctx.textAlign = "left";
    let part2Value = this.maxValue - perValue
    let part2Height = top + perHeight
    ctx.fillText(part2Value.toFixed(ratioFixed), left, part2Height);
    ctx.textAlign = "right";
    let part2Rate = 100 * (part2Value - this.baseValue) / this.baseValue
    ctx.fillText(part2Rate.toFixed(2) + '%', right, part2Height);

    // 第三条
    ctx.textAlign = "left";
    let part3Value = this.maxValue - perValue * 2
    let part3Height = top + perHeight * 2
    ctx.fillText(part3Value.toFixed(ratioFixed), left, part3Height);
    ctx.textAlign = "right";
    let part3Rate = 100 * (part3Value - this.baseValue) / this.baseValue
    ctx.fillText(part3Rate.toFixed(2) + '%', right, part3Height);

    // 中轴线
    ctx.textAlign = "left";
    ctx.fillStyle = color;
    const halfHeight = top + height / 2;
    ctx.fillText(this.baseValue.toFixed(ratioFixed), left, halfHeight);
    ctx.textAlign = "right";
    ctx.fillText('0.00%', right, halfHeight);

    // 第五条
    ctx.textAlign = "left";
    ctx.fillStyle = this.option.BaseContext.colorMap[0];
    let part5Value = this.baseValue - perValue
    let part5Height = top + perHeight * 4
    ctx.fillText(part5Value.toFixed(ratioFixed), left, part5Height);
    ctx.textAlign = "right";
    let part5Rate = 100 * (this.baseValue - part5Value) / this.baseValue
    ctx.fillText(part5Rate.toFixed(2) + '%', right, part5Height);

    // 第六条
    ctx.textAlign = "left";
    let part6Value = this.baseValue - perValue * 2
    let part6Height = top + perHeight * 5
    ctx.fillText(part6Value.toFixed(ratioFixed), left, part6Height);
    ctx.textAlign = "right";
    let part6Rate = 100 * (this.baseValue - part6Value) / this.baseValue
    ctx.fillText(part6Rate.toFixed(2) + '%', right, part6Height);

    // 最低
    ctx.textAlign = "left";
    const minPercent = 100 * (this.baseValue - this.minValue) / this.baseValue;
    ctx.fillText(this.minValue.toFixed(ratioFixed), left, bottom);
    ctx.textAlign = "right";
    ctx.fillText(minPercent.toFixed(2) + '%', right, bottom);
  }
  _calcCursorAxis(index) {
    const { last_px, start } = this.state.data;
    /*** 绘制Y轴标签 ***/
    const data = last_px[index];
    if (data) {
      const text = data.value;
      const y = data.lineY;
      return { text, y }
    }
  }
  // @checkMainTitleAuth
  _drawTitle() {
    const defaultText = '- -';
    const ctx2 = this.curContext;
    const {
      last_px,
      avg_px,
      current,
      showAvg,
      sealObj,
      code,
    } = this.state.data;
    const { height, top, baseSize } = this.state;
    const { ratioFixed, hqTypeCode, preClosePx } = sealObj;
    const {
      title,
      avgLine
    } = this.option.Trend;
    const {
      sizeRatio,
      fontFamily,
      space,
      textSpace,
    } = title;
    const { baseLine } = this.option.MainContext.title;
    const baseLineY = top + height * baseLine;
    const { colorMap } = this.option.BaseContext;
    let { left, right } = this.availArea;
    ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
    ctx2.fillStyle = title.color;
    ctx2.textAlign = 'left';
    ctx2.textBaseline = 'middle';
    ctx2.beginPath();
    let text, textWidth;
    if (showAvg) {
      if (checkMRI(code, hqTypeCode)) {
        text = '领先:';
      } else {
        text = '均价:';
      }
      textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth + textSpace * this.dpr;

      ctx2.fillStyle = avgLine.color;
      const item = avg_px[current];
      if (Util.isDef(item) && Util.isValidNumber(item.value)) {
        text = item.value.toFixed(ratioFixed);
      } else {
        text = defaultText;
      }
      textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth + space * this.dpr;
    }
    const item = last_px[current];
    if (Util.isDef(item) && Util.isValidNumber(item.value)) {
      text = '最新:';
      ctx2.fillStyle = title.color;
      textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth + textSpace * this.dpr;

      let textArr = [];
      let diff;
      textArr.push(item.value.toFixed(ratioFixed));
      if (Util.isValidNumber(preClosePx)) {
        diff = item.value - preClosePx;
        if (diff > 0) {
          ctx2.fillStyle = colorMap[1];
          textArr.push('+' + diff.toFixed(ratioFixed));
          if (preClosePx == 0) {
            textArr.push('+' + defaultText + '%');
          } else {
            textArr.push('+' + (100 * diff / preClosePx).toFixed(2) + '%');
          }
        } else {
          if (diff < 0) {
            ctx2.fillStyle = colorMap[0];
          }
          textArr.push(diff.toFixed(ratioFixed));
          textArr.push((100 * diff / preClosePx).toFixed(2) + '%');
        }
      }
      text = textArr.join('  ');
      ctx2.fillText(text, left, baseLineY);
    }
    // 港股延迟15分钟
    if (checkHKM(code) || checkAmerican(code)) {
      const {
        sizeRatio,
        fontFamily,
        color,
        defaultText
      } = this.option.MainContext.tips;
      ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
      ctx2.fillStyle = color;
      ctx2.textAlign = 'right';
      ctx2.fillText(defaultText, right, baseLineY);
    }
  }
}
